import { Component, OnInit } from '@angular/core';
import { AbstractProfileValidator } from '../../base/abstract-profile-validator';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FieldConfig } from '@biletix/core/models/base/field-config.model';

@Component({
  standalone: false,
  selector: 'btx-hopi-token-profile-validator',
  templateUrl: './hopi-token-profile-validator.component.html',
  styleUrls: ['./hopi-token-profile-validator.component.scss']
})
export class HopiTokenProfileValidatorComponent extends AbstractProfileValidator implements OnInit  {

  hopiTokenValidationForm!: FormGroup;

    fieldConfig: FieldConfig | any;

    isDiscountApplied: boolean = false;

    constructor(fb: FormBuilder) {
        super(fb);
    }

    ngOnInit(): void {

        //
        this.fieldConfig = this.validationFieldConfigs[0];
        this.initializeTokenForm();

    }

    initializeTokenForm() {
        this.hopiTokenValidationForm = this.addValidationFieldItems([this.fieldConfig])!;
    }


    onValidateProfile() {
        if (this.hopiTokenValidationForm.invalid || this.isDiscountApplied) {
            this.hopiTokenValidationForm.markAllAsTouched();
            return;
        }

        //TODO: Token validate
        let formValue = this.hopiTokenValidationForm.value;

    }

}
